import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toUpperStr',
  standalone: true
})
export class ToUpperStrPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) {
      return value ?? '';
    }

    return value.toUpperCase();
  }
}
